import { InjectionToken } from '@angular/core';

export const API_URL = new InjectionToken<string>('');

export const API_RESERVATION_URL = new InjectionToken('');

export const GUEST_URL = new InjectionToken('');

export const MENU_UPLOADER_URL = new InjectionToken('');

export const ASSISTANTS_URL = new InjectionToken('');

export const ASSISTANTS_WS_URL = new InjectionToken('');
